import { adminEvent, ContractTypes, getFilterShiftType, pharmacyEvents, selectWorkshiftList } from '@pharmaplan/common';
import { filterByLongTerm, filterByShortTerm } from '@pharmaplan/common/helpers/utils';
import { useAppSelector } from './useAppSelector';

const { shortTerm, longTerm } = ContractTypes;

const useMultiShiftFilter = () => {
  const pharmacistEvents = useAppSelector(selectWorkshiftList);
  const pharmacyEventsList = useAppSelector(pharmacyEvents);
  const adminEvents = useAppSelector(adminEvent);

  const filterShiftType = useAppSelector(getFilterShiftType);

  const shiftTypeFilter = () => {
    switch (filterShiftType) {
      case longTerm.toString():
        return {
          pharmacistEvents: pharmacistEvents.filter(filterByLongTerm),
          pharmacyEventsList: pharmacyEventsList.filter(filterByLongTerm),
          adminEvents: adminEvents.filter(filterByLongTerm),
        };
      case shortTerm.toString():
        return {
          pharmacistEvents: pharmacistEvents.filter(filterByShortTerm),
          pharmacyEventsList: pharmacyEventsList.filter(filterByShortTerm),
          adminEvents: adminEvents.filter(filterByShortTerm),
        };
      default:
        return {
          pharmacistEvents,
          pharmacyEventsList,
          adminEvents,
        };
    }
  };

  return shiftTypeFilter();
};

export default useMultiShiftFilter;
